<template>
    <div  v-if="refresh">
        <!-- <InputText
                v-model:inputValue="formModel.firstname"
                :errorInfo="errorInfo[0]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.shipping.firstname"
        ></InputText>
        <InputText
                v-model:inputValue="formModel.lastname"
                :errorInfo="errorInfo[1]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.shipping.lastname"
        ></InputText>
        <InputContactNumber
                v-model:inputValue="formModel.contactNumber"
                :minLength="10"
                :maxLength="12"
                delimeter="-"
                :errorInfo="errorInfo[2]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.shipping.contactnumber"
        ></InputContactNumber>
        <InputText
                v-model:inputValue="formModel.address"
                :errorInfo="errorInfo[3]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.shipping.address"
        ></InputText>
        <FormAddressDropdown
                v-model:inputValue="addressModel"
                :errorInfo="errorInfo[4]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.shipping"
        ></FormAddressDropdown> -->
    </div>
</template>
<script>
import { FormHelper } from "@/helper/FormHelper.js";
//component
// import InputText from "@/components/Input/label/InputText.vue";
// import InputContactNumber from "@/components/Input/label/InputContactNumber.vue";
// import FormAddressDropdown from "@/components/Form/FormAddressDropdown.vue";
//mixin
//service
import { AddressModel } from "@/core/Address/model/AddressModel.js";
import { FormAddressModel } from "../model/FormAddressModel.js";

export default {
    name: "FormShippingAddress",
    components: {
        // InputText,
        // InputContactNumber,
        // FormAddressDropdown,
    },
    data: function() {
        return {
            isSubmitted: false,
            errorInfo: [],
            refresh: true,

            formModel: null,
            addressModel: null,
        };
    },
    created: function() {
        this.initForm(null);
        this.errorInfo = FormHelper.genErrorInfo(5);
    },
    methods: {
        initForm: function() {
            this.isSubmitted = false;

            this.addressModel = new AddressModel();
            this.formModel = new FormAddressModel();

            this.refresh = false;
            this.$nextTick(() => {
                this.refresh = true;
            });
        },

        clearForm: function() {
            this.initForm(null);
        },
        submitForm: function() {
            this.isSubmitted = true;
            if (this.validate()) {
                this.formModel.setValueFromAddressModel(this.addressModel);
                // this.addressModel.setValueFromAddressModel(this.formAddressModel);
                return this.formModel;
            }
            return null
        },
        validate: function() {
            return FormHelper.validate(this.errorInfo);
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
